
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Angenommen wurden Plastiksäckli mit `}<nobr>{`2,2 g Gewicht`}</nobr>{` aus LDPE, also Polyethylen mit geringer Dichte. Berücksichtigt wurden die Treibhausgasemissionen in der Produktion, beim Transport des Säcklis zum Detailhändler sowie bei der Entsorgung in einer Kehrichtverbrennungsanlage.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;